import React, { useState, useEffect } from 'react';
import AdminBlogs from './AdminBlogs';
import AdminTemplates from './AdminTemplates';
import AdminPortfolio from './AdminPortfolio';
import { ADMIN_PASSWORD, AUTH_KEY, inputStyle, TabButton } from './adminShared';

function AdminPanel() {
  const [authed, setAuthed] = useState(false);
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [activeTab, setActiveTab] = useState('blog');

  useEffect(() => {
    if (sessionStorage.getItem(AUTH_KEY) === 'true') {
      setAuthed(true);
    }
  }, []);

  function handleLogin(e) {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      sessionStorage.setItem(AUTH_KEY, 'true');
      setAuthed(true);
      setLoginError('');
    } else {
      setLoginError('Hatalı şifre.');
    }
  }

  function handleLogout() {
    sessionStorage.removeItem(AUTH_KEY);
    setAuthed(false);
    setPassword('');
  }

  if (!authed) {
    return (
      <section className="section-padding" style={{ minHeight: '70vh' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div
                className="p-40"
                style={{
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '12px',
                }}
              >
                <h4 className="mb-10">Admin Girişi</h4>
                <p className="p-color fz-14 mb-30">Kanus Digital yönetim paneli</p>
                <form onSubmit={handleLogin}>
                  <div className="mb-20">
                    <label className="sub-title fz-12 mb-10 d-block">Şifre</label>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Admin şifrenizi girin"
                      required
                      style={inputStyle}
                    />
                  </div>
                  {loginError && <p className="main-color fz-14 mb-20">{loginError}</p>}
                  <button
                    type="submit"
                    className="butn butn-sm butn-bg main-colorbg radius-5"
                    style={{ border: 'none', cursor: 'pointer' }}
                  >
                    <span className="text">Giriş Yap</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section-padding">
      <div className="container">
        <div className="d-flex align-items-center flex-wrap mb-40" style={{ gap: '12px' }}>
          <div className="d-flex align-items-center" style={{ gap: '10px' }}>
            <TabButton active={activeTab === 'blog'} onClick={() => setActiveTab('blog')}>
              Blog Yönetimi
            </TabButton>
            <TabButton active={activeTab === 'templates'} onClick={() => setActiveTab('templates')}>
              Şablon Yönetimi
            </TabButton>
            <TabButton active={activeTab === 'portfolio'} onClick={() => setActiveTab('portfolio')}>
              Portfolio Yönetimi
            </TabButton>
          </div>
          <button
            onClick={handleLogout}
            className="butn butn-sm butn-bord radius-30 ml-auto"
            style={{ border: 'none', cursor: 'pointer' }}
          >
            <span>Çıkış</span>
          </button>
        </div>

        {activeTab === 'blog' && <AdminBlogs />}
        {activeTab === 'templates' && <AdminTemplates />}
        {activeTab === 'portfolio' && <AdminPortfolio />}
      </div>
    </section>
  );
}

export default AdminPanel;
